export namespace Subscription {
  export type ListenerId = string

  export type Unsubscribers = Record<ListenerId, Functions.Unsubscribe>

  export const cancel = (
    unsubscribers: Unsubscribers,
    listenerId: ListenerId
  ) => {
    const { [listenerId]: unsubscribe, ...rest } = unsubscribers

    unsubscribe()

    return rest
  }

  export const cancelAll = (unsubscribers: Unsubscribers) => {
    Object.values(unsubscribers).forEach((unsubscribe) => {
      return unsubscribe()
    })
  }

  export namespace Functions {
    export type Unsubscribe = () => void
  }
}
